/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MagicTokenAnonymousRequest
 */
export interface MagicTokenAnonymousRequest {
    /**
     * The e-mail address of the user requesting the magic token.
     * @type {string}
     * @memberof MagicTokenAnonymousRequest
     */
    email: string;
    /**
     * This is the target of the request. It is used to redirect the user to the proper app after consuming the token.
     * @type {string}
     * @memberof MagicTokenAnonymousRequest
     */
    target: MagicTokenAnonymousRequestTargetEnum;
}


/**
 * @export
 */
export const MagicTokenAnonymousRequestTargetEnum = {
    Unknown: 'UNKNOWN',
    ChatAppLocal: 'CHAT_APP_LOCAL',
    ChatAppDev: 'CHAT_APP_DEV',
    ChatApp: 'CHAT_APP',
    WebAppLocal: 'WEB_APP_LOCAL',
    WebAppDev: 'WEB_APP_DEV',
    WebApp: 'WEB_APP'
} as const;
export type MagicTokenAnonymousRequestTargetEnum = typeof MagicTokenAnonymousRequestTargetEnum[keyof typeof MagicTokenAnonymousRequestTargetEnum];


/**
 * Check if a given object implements the MagicTokenAnonymousRequest interface.
 */
export function instanceOfMagicTokenAnonymousRequest(value: object): value is MagicTokenAnonymousRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function MagicTokenAnonymousRequestFromJSON(json: any): MagicTokenAnonymousRequest {
    return MagicTokenAnonymousRequestFromJSONTyped(json, false);
}

export function MagicTokenAnonymousRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicTokenAnonymousRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'target': json['target'],
    };
}

export function MagicTokenAnonymousRequestToJSON(json: any): MagicTokenAnonymousRequest {
    return MagicTokenAnonymousRequestToJSONTyped(json, false);
}

export function MagicTokenAnonymousRequestToJSONTyped(value?: MagicTokenAnonymousRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'target': value['target'],
    };
}

